import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

//import Accordion from 'react-bootstrap/Accordion';
import { PublicAccordion } from 'Components/Public/Accordion/PublicAccordion';
import { ICONS } from 'Utils/icons';
//import { Stack } from 'react-bootstrap';
import { IconTextButton, TextButton } from 'Components/Button';
import { NumberedSteps, NumberedStepsSplit } from 'Components/Public/NumberedSteps/NumberedSteps';
//import { ArrowRight, Favorite, PlayCircle, ThumbDown, ThumbDownAltOutlined, ThumbUp } from '@mui/icons-material';
//import reCAPTCHA from 'Images/recaptchaimg.png';
//import ahrqlogo from 'Images/ahrqlogo.png';
import settinguppso from 'Images/public/card-header-images/Setting up your PSO Profile.png';
import defaultarticleimg from 'Images/public/card-header-images/DefaultArticleImage.png';
import trainingslides from 'Images/public/card-header-images/2024 PSO Profile Training Slides.png';
//import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { PageHeader } from 'Components/Public/PageHeader/PageHeader';
//import { FloatingCallToAction } from 'Components/Public/FloatingCallToAction/FloatingCallToAction';
import { DidFindPrompt } from 'Components/Public/DidFindPrompt/DidFindPrompt';
import { NextPage } from 'Components/Public/NextPage/NextPage';
//import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'Utils/PagePaths';
import { getDocInfo, handleFileDownload, isLoggedIn, openInNewTab } from 'Utils/utilityFunctions';
//import checkIcon from 'Images/shieldcheck.png';
//import datasetIcon from 'Images/Dataset.png';
//import postIcon from 'Images/postplus.png';
//import connectIcon from 'Images/connect.png';

import { useEffect, useState } from 'react';
import ArticleCard from 'Components/Public/ArticleCards/ArticleCard';
import Feedback from "../../../Components/Public/Feedback/Feedback";
import { ReCaptchaWrapper } from "../../../Components/ReCaptcha";
import DownloadLink from 'Components/Public/DownloadLink/DownloadLink';

//DOWNLOAD
function BecomeAPSO () {

    const navigate = useNavigate();
    const [doc145, setDoc145] = useState(null);
    const [doc2856, setDoc2856] = useState(null);
    const [doc2062, setDoc2062] = useState(null);
    const step3Description =
        <>
            <p>
                Next, fill in some details about your PSO in the PSO Profile. The information you include will be shown in <a href={`https://pso.ahrq.gov/pso/listed`} target={`_blank`} className={`external-link`}>AHRQ's PSO selection tool</a> that providers use to find PSOs. Update your profile once a year with the latest information.
            </p>
        </>;


    useEffect(() => {
        getDocInfo(145, setDoc145);
        getDocInfo(2856, setDoc2856);
        getDocInfo(2062, setDoc2062);
    }, [])

    

    return (
      <>
        <ReCaptchaWrapper
            action="become_a_pso_landing"
            title="Become a PSO"
        >
            <Row className="m-0 p-0">
                <PageHeader
                    title="Become a PSO"
                    intro="If your organization's primary mission and work focuses on improving patient safety and the quality of healthcare delivery, you may be eligible to become a PSO."
                >
                    <h2 className="public-title text-center mb-3">Benefits of being a PSO:</h2>
                    <Row className="blue-text public-cards col-gap2 row-gap-3">

                        <Col className="" lg={6}>
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column flex-md-row align-items-start">
                                    <div className="number-bg align-items-center">
                                        <div className="mb-1"><span className="displayXS semibold">1</span></div>
                                    </div>

                                    <div className="">
                                        <div className="text-start mb-2"><span className="public-card-header horizontal header2">Legal Protection</span></div>
                                        <div className="public-card-content ">
                                            <p>Under the <a target="_blank" className="external-link" href="https://pso.ahrq.gov/resources/act">Patient Safety Act</a>, confidentiality and privilege protections only apply when healthcare providers work with PSOs.</p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col className="" lg={6}>
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column flex-md-row align-items-start">
                                    <div className="number-bg align-items-center">
                                        <div className="mb-1"><span className="displayXS semibold">2</span></div>
                                    </div>
                                    <div>
                                        <div className="text-start mb-2"><span className="public-card-header horizontal header2">Public Listing</span></div>
                                        <div className="public-card-content ">
                                            <p>Once approved, your PSO will be listed by the HHS Secretary on the <a target="_blank" href="https://pso.ahrq.gov/pso/listed" className="external-link" >AHRQ website</a> to help healthcare providers find your PSO.</p>
                                        </div>
                                    </div>

                                </Card.Body>
                            </Card>
                        </Col>
                        <Col className="" lg={6}>
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column flex-md-row align-items-start">
                                    <div className="number-bg align-items-center">
                                        <div className="mb-1"><span className="displayXS semibold">3</span></div>
                                    </div>
                                    <div>
                                        <div className="text-start mb-2"><span className="public-card-header horizontal header2 ">Contribution to National Learning</span></div>
                                        <div className="public-card-content ">
                                            <p>As a PSO, you can work with PSOPPC to submit patient safety data to the <a target="_blank" href="https://www.ahrq.gov/npsd/index.html" className="external-link" >Network of Patient Safety Databases (NPSD)</a>. You will gain access to de-identified data from across the nation, as well as trends and analyses from our subject matter experts.</p>
                                        </div>
                                    </div>

                                </Card.Body>
                            </Card>
                        </Col>
                        <Col className="" lg={6}>
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column flex-md-row align-items-start">
                                    <div className="number-bg align-items-center">
                                        <div className="mb-1"><span className="displayXS semibold">4</span></div>
                                    </div>
                                    <div>
                                        <div className="text-start mb-2"><span className="public-card-header horizontal header2">Insights into Your Own Data</span></div>
                                        <div className="public-card-content body">
                                            <p>Gain access to interactive, PSO-specific dashboards that visualize the data you submit. These personalized analyses can help your organization identify trends, uncover risks, and track improvement opportunities using real-time data.</p>
                                        </div>
                                    </div>

                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                </PageHeader>


                <Row lg={1} className="main-content m-0 mb-5 mt-5 pt-4 pb-4 d-flex justify-content-center g-0">

                    <Col lg="11" xs="11">
                        <div className="steps align-items">
                            <div className="step-title d-block d-md-grid m-0 p-2 p-md-0">
                                <h3 className="text-start" id="follow-these-steps">
                                    Follow these steps
                                </h3>
                            </div>

                            <NumberedStepsSplit
                                number={'01'}
                                stepTitle="How to become a PSO"
                                stepText={"Review the requirements for PSO initial listing and prepare to submit your certification."}
                                stepContent={
                                    <IconTextButton variant="normal" icon={ICONS.launch} content="Learn more on pso.ahrq.gov" onClick={() => { openInNewTab('https://pso.ahrq.gov/become') }} className="reverse w-xs-100 w-sm-fit-content d-flex justify-content-center"></IconTextButton>
                                }
                            >
                            </NumberedStepsSplit>
                            <NumberedStepsSplit
                                number={'02'}
                                stepTitle="Apply to become a PSO"
                                stepText={"To be listed as a PSO, fill out the form and submit it to AHRQ for review and approval."}
                                stepContent={
                                    <IconTextButton variant="normal" icon={ICONS.launch} content="Register on pso.ahrq.gov" onClick={() => { openInNewTab('https://pso.ahrq.gov/forms/initial-listing') }} className="reverse w-xs-100 w-sm-fit-content d-flex justify-content-center"></IconTextButton>
                                }
                            >
                            </NumberedStepsSplit>

                            <NumberedStepsSplit
                                number={'03'}
                                className="cards-step"
                                stepTitle="Fill out your PSO Profile"
                                elementId={`step-03`}
                                stepText={step3Description}
                                stepContent={
                                    <>
                                        {
                                            isLoggedIn() == true
                                                ? null
                                                : <div className="d-flex flex-column gap-3  w-xxs-100 w-sm-fit-content align-items-start">
                                                    <TextButton variant="normal" content="Fill out your profile" onClick={() => navigate(PATHS.public['Sign In'])} className="w-100"></TextButton>
                                                    <TextButton variant="outline" content="Update your profile" onClick={() => navigate(PATHS.public['Sign In'])} className="w-100"></TextButton>
                                                </div>
                                        }


                                    </>
                                }
                                dashedClasses="grid-row-end-md-4"
                                splitSecClasses="grid-row-md-3 grid-col-start-md-2 grid-col-end-md-4 m-0 "
                            >
                                {/**/}
                                <Row md={1} lg={3} className="article-cards has-max g-0 gy-lg-4 gap-0 gap-4 gap-lg-2 gap-xl-3 w-100 mb-5 d-flex flex-wrap  flex-column flex-lg-row  justify-content-lg-between">
                                    <Col className="article-card-col w-100">
                                        <ArticleCard groupId={2855} image={defaultarticleimg} imageAlt={"PSO Privacy Protection Center Logo"} text={() => { return (<>Use this hard copy to help you and your staff gather answers to the questions before signing in to complete the form. <b>Note: You are required to sign in to complete the PSO Profile Form.</b></>) }} isVideo={false} action={() => handleFileDownload(2855)}></ArticleCard>
                                    </Col>
                                    <Col className="article-card-col w-100">
                                        <Card variant="article-card" className="article-card h-100" as={Button} role="button" onClick={() => {
                                            openInNewTab("https://psoppc-community-video.s3.amazonaws.com/2025-profile/2025_PSO_Profile_Training_Video.html")
                                        }}>
                                            <div className="card-con video">
                                                <Card.Img variant="top" src={settinguppso} alt="Screenshot of PSO Profile Training Video"></Card.Img>
                                            </div>
                                            <Card.Body className="p-4">
                                                <Card.Title>Setting up your PSO Profile</Card.Title>
                                                <Card.Text>Learn how to set up your PSO Profile from start to finish. </Card.Text>
                                                <Card.Footer className="p-0 mt-auto">December 19th, 2025</Card.Footer>
                                            </Card.Body>

                                        </Card>
                                    </Col>
                                    <Col className="article-card-col w-100">
                                        <ArticleCard groupId={2062} image={defaultarticleimg} imageAlt={"PSO Privacy Protection Center Logo"} text={"Learn more about how to navigate your PSO Profile to include your healthcare partners."} isVideo={false} action={() => handleFileDownload(2062)}></ArticleCard>
                                    </Col>
                                    <Col className="article-card-col w-100">
                                        <ArticleCard groupId={2856} image={trainingslides} imageAlt={"First page of the PSO Profile Training Slides"} text={"View our training slides to help complete your PSO Profile."} isVideo={false} action={() => handleFileDownload(2856)}></ArticleCard>
                                    </Col>
                                </Row>
                            </NumberedStepsSplit>
                            <NumberedStepsSplit
                                number={'04'}
                                stepTitle="Grant access to your team"
                                stepText={"Grant your PSO workforce teammates the necessary permissions to submit PSO profile information, submit patient safety data, and review reports."}
                                stepContent={
                                    <TextButton variant="normal" content="Account Setup" onClick={() => navigate(PATHS.public['User Account Types'])} className="w-xs-100 w-sm-fit-content justify-content-center"></TextButton>
                                }
                            >

                            </NumberedStepsSplit>
                            <NumberedStepsSplit
                                number={'05'}
                                stepTitle="Grant your vendors access"
                                stepText={"If you work with a vendor and you'd like them to submit data on your behalf, grant them access."}
                                stepContent={

                                    isLoggedIn() == true
                                        ? null
                                        : <TextButton variant="normal" content="Grant access to vendors" onClick={() => navigate(PATHS.public['Sign In'])} className="w-xs-100 w-sm-fit-content justify-content-center"></TextButton>


                                }
                                className="cards-step"
                                dashedClasses="grid-row-end-lg-4"
                                splitSecClasses="grid-row-xs-4 grid-col-start-xs-2 grid-col-end-xs-4 grid-row-start-lg-2 grid-row-end-lg-3 grid-col-start-lg-3 grid-col-end-lg-4 m-0 w-100"
                            >
                                {/*<Row lg="1" className="article-cards small gap-5 g-0 w-100 mt-5 justify-content-md-end">*/}
                                <Row lg="1" className="article-cards has-max gap-4 gap-lg-3 gap-xl-5 g-0 gap-0 w-100 mb-5 d-flex flex-wrap flex-lg-nowrap flex-column flex-lg-row  justify-content-md-end">
                                    {/*<Card className="article-card" role="button" as={Button}  onClick={()=>handleFileDownload(145)}>
                                        <div className="card-con">
                                            <Card.Img variant="top" alt="PSO Privacy Protection Center Logo" src={defaultarticleimg}></Card.Img>
                                        </div>
                                        <Card.Body className="p-4">
                                            <Card.Title>PSOPPC Vendor Organization Account Setup Process</Card.Title>
                                            <Card.Text>Learn how to establish vendor access in PSOPPC.</Card.Text>
                                            <Card.Footer className="p-0 mt-auto">{doc145!=null ? formatDocDate(doc145.documentTagInfo.postedOn) : null}</Card.Footer>
                                        </Card.Body>
                                    </Card>*/}
                                    <ArticleCard groupId={145} image={defaultarticleimg} imageAlt={"PSO Privacy Protection Center Logo"} text={"Learn how to establish vendor access in PSOPPC."} isVideo={false} action={() => handleFileDownload(145)}></ArticleCard>

                                </Row>
                            </NumberedStepsSplit>



                        </div>
                    </Col>


                </Row>

            </Row>
            <Row className="faq m-0 d-flex justify-content-center">
                <Col lg="10">
                    <h2 className="mb-5" id="become-a-pso-faq">Frequently Asked Questions</h2>
                    <PublicAccordion
                        defaultActiveKey={[]}
                        accordionItemsContent={[
                            {
                                header: "What are the password requirements for the PSOPPC profile?",
                                content: () => {
                                    return (
                                        <>
                                            <p className="mb-0">Contains 16-24 characters</p>
                                            <p className="mb-0">Contains three of the four character types:</p>
                                            <ul className="mb-0 ps-0">
                                                <li>- Uppercase character</li>
                                                <li>- Lowercase character Number</li>
                                                <li>- Valid Special characters: ! @ # $ % & * ( ) _ = +</li>
                                                <li>- [ ] ?</li>
                                            </ul>

                                            <p className="mb-0">Does not contain the User ID, First Name, Last Name</p>
                                            <p className="mb-0">Can be only changed once in a 24-hour period</p>
                                        </>
                                    )
                                }
                            },
                            {
                                elementId: "faq-question-02",
                                header: "Why is submitting my PSO Profile important?",
                                content: () => {
                                    return (
                                        <>
                                            <p>
                                                Federally listed Patient Safety Organizations (PSOs) are strongly encouraged by the Agency for Healthcare
                                                Research and Quality (AHRQ) to complete the PSO Profile annually. Submitting and maintaining an
                                                up-to-date PSOPPC profile helps ensure your organization’s information is accurate, current, and
                                                reflected across federal systems.
                                                {/* <a href="https://pso.ahrq.gov/listed">https://pso.ahrq.gov/listed</a>. */}
                                            </p>
                                            <p>
                                                PSO Profile data supports AHRQ by providing aggregate information used to administer the Patient
                                                Safety and Quality Improvement Act (PSQIA) and to understand the reach and focus of PSO activities
                                                nationwide.
                                            </p>
                                            <p>
                                                For PSOs, completing the profile also offers direct benefits. Profile information is used to populate
                                                AHRQ's PSO Selection Tool, helping providers identify PSOs that align with their needs. An accurate
                                                profile increases your visibility to potential providers, supports transparency, and helps ensure your
                                                organization is represented correctly in national reporting and outreach efforts.
                                            </p>
                                            <p>
                                                Learn more about the PSO Selection Tool at <a target="_blank" href="https://pso.ahrq.gov/listed">https://pso.ahrq.gov/listed</a>.
                                            </p>
                                        </>
                                    )
                                }
                            },
                            {
                                header: "How do I count the providers my PSO serves for my PSO Profile?",
                                content: () => {
                                    return (
                                        <>


                                            <p className="mb-0">
                                                Take a look at our guidelines on <DownloadLink groupId={2062} linktext="Provider counts in the PSO Profile"></DownloadLink>.
                                            </p>
                                        </>
                                    )
                                }
                            }
                        ]}
                    ></PublicAccordion>

                </Col>
            </Row>

            <DidFindPrompt></DidFindPrompt>

            <Feedback/>
                
            <NextPage
                path={PATHS.public['Current Common Formats']}
                text="Current Common Formats"
                backPath={PATHS.public['Homepage']}
                backPathText="Home"
            ></NextPage>


        </ReCaptchaWrapper>
    </>
    );
}

export default BecomeAPSO;
